var map = {
	"./AMERICAS_Mexico_Tuxpan_Aerial_Tanks_2021-06_1920x550.jpg": 27032,
	"./Oiltanking_Belgium_Antwerp_Gas_Terminal_NV_Image_tanks1_1920px.jpg": 97587,
	"./Oiltanking_South-America_Argentina_Puerto-Rosales_Tanks_2009-03-04_1070341.jpg": 50466,
	"./Oiltanking_South-America_Brazil_Vitoria_Tanks-Landscape_2012-06-28_10.jpg": 69354,
	"./Oiltanking_South-America_Brazil_Vitoria_Truckloading_2012-06-29_0942.jpg": 11869,
	"./Oiltanking_South-America_Colombia_Cartagena_Terminal-Aerial_2011-06-10.jpg": 6470,
	"./Oiltanking_South-America_Peru_Callao.jpg": 10968,
	"./Oiltanking_South-America_Peru_Callao_old.jpg": 76270,
	"./Oiltanking_South-America_Peru_Chimbote_Tank_2016-10-13_1.jpg": 98645,
	"./Oiltanking_South-America_Port-Acu.jpg": 44214,
	"./Terminal Page Puerto Bahia.jpg": 69194,
	"./image_ot-panama-coassa-colon_tanks1_1920px.jpg": 874,
	"./image_ot-peru-andina-services_marine-platform1_1920px.jpg": 49851,
	"./image_ot-peru-eten_tanks_1920px.jpg": 32515,
	"./image_ot-peru-matarani_tanks1_1920px.jpg": 52971,
	"./image_ot-peru-salaverry_tanks2_1920px.jpg": 39716,
	"./image_ot-peru-supe_tanks_1920px.jpg": 96778,
	"./otSouthAmericaArgentinaBrandsenTerminal.jpg": 21733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 185;